import Image from './image';

export default Image;

export {
  ImageProps,
  ImagePreviewProps,
  ImagePreviewGroupProps,
  ImagePreviewActionProps,
} from './interface';
